import { useState } from "react";
import { RunSheet } from "./RunSheet";
import { useOfficialWrite, type RiderSheetProps } from "@/components/official/shared";
import type { RunState } from "./model";
export function ModifierSheet(
  props: RiderSheetProps & { definitions: NonNullable<RunState["modifiers"]> },
) {
  const [modifier, setModifier] = useState("");
  const [reason, setReason] = useState("");
  const [dsq, setDsq] = useState("other");
  const { busy, error, write, execute, undo } = useOfficialWrite(props);
  const attempt = props.rider.attempts.find(
    (a) => a.attempt_number === props.rider.current_attempt,
  );
  const selected = props.definitions.find((d) => d.id === modifier);
  return (
    <RunSheet title="Apply modifier" close={props.onClose}>
      <p>
        {props.rider.name} · Attempt {props.rider.current_attempt}
      </p>
      {error && <p role="alert">{error}</p>}
      {undo}
      {(attempt?.applied_modifiers ?? []).map((m) => (
        <div key={m.id}>
          <span>{m.name}</span>
          {props.definitions.some((d) => d.id === m.id) && (
            <button
              disabled={busy || attempt?.version === undefined}
              onClick={() =>
                void write(() =>
                  execute("modifier", {
                    heat_rider_id: props.rider.heat_rider_id,
                    attempt_number: props.rider.current_attempt,
                    expected_version: attempt?.version,
                    applied_modifiers: attempt?.applied_modifiers
                      ?.filter((a) => a.id !== m.id)
                      .map((a) => a.id),
                    reason: reason.trim() || undefined,
                  }),
                )
              }
            >
              Remove {m.name}
            </button>
          )}
        </div>
      ))}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          void write(() =>
            execute("modifier", {
              heat_rider_id: props.rider.heat_rider_id,
              attempt_number: props.rider.current_attempt,
              modifier_id: modifier,
              ...(reason.trim() ? { reason: reason.trim() } : {}),
              ...(selected?.sets_status === "dsq" ? { dsq_reason: dsq } : {}),
            }),
          );
        }}
      >
        <label>
          Modifier
          <select required value={modifier} onChange={(e) => setModifier(e.target.value)}>
            <option value="">Select a modifier</option>
            {props.definitions.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
        </label>
        {selected?.sets_status === "dsq" && (
          <label>
            DSQ reason
            <select value={dsq} onChange={(e) => setDsq(e.target.value)}>
              <option value="unsportsmanlike">Unsportsmanlike</option>
              <option value="safety">Safety</option>
              <option value="other">Other</option>
            </select>
          </label>
        )}
        <label>
          Reason
          <textarea maxLength={2000} value={reason} onChange={(e) => setReason(e.target.value)} />
        </label>
        <button className="run-primary" disabled={busy || !modifier}>
          Apply modifier
        </button>
      </form>
    </RunSheet>
  );
}
